module.exports = __webpack_public_path__ + "31392a3e876588887d3b038532d85a17.MP3";